<template>
  <div class="row my-2">
    <FilterState class="col-xl col-12" v-if="filterSate" />
    <div class="col-xl col-12 pt-4" v-if="filterName">
      <input
        placeholder="Buscar..."
        type="text"
        class="form-control mt-3"
        v-model="name"
        v-on:input="handleSetFilterName()"
      />
    </div>
    <div class="col-xl col-12 pb-1" v-if="filterAmountElements">
      <p class="text-center">Cantidad a mostrar</p>
      <select class="form-control" v-on:change="handleSetAmountElements()" v-model="amountElements">
        <option value="50" selected>50</option>
        <option value="100">100</option>
        <option value="200">200</option>
        <option value="500">500</option>
        <option value="-1">Todos</option>
      </select>
      <!-- <input
        placeholder="Cantidad a mostrar"
        type="text"
        class="form-control mt-3"
        v-model="amountElements"
        v-on:input="handleSetAmountElements()"
      /> -->
    </div>
    <OrderBy class="col-md col-12" v-if="filterMenu" />
  </div>
</template>

<script>
import FilterState from "@/components/admin/filters/FilterState.vue";
import OrderBy from "@/components/admin/filters/OrderBy.vue";

export default {
  name: "FilterMenu",
  props: {
    filterSate: Boolean,
    filterMenu: Boolean,
    filterName: Boolean,
    filterAmountElements: Boolean,
    typePublication: String,
  },
  data() {
    return {
      amountElements: 50,
      name: "",
      filterStateParms: {
        active: true,
        inactive: true,
        cancel: true,
      },
    };
  },
  components: {
    FilterState,
    OrderBy,
  },
  methods: {
    handleSetAmountElements() {
      if(this.amountElements == '-1') {
        this.$parent.filterMenuParms.filterAmountElements = 50000;
        return;
      }
      this.$parent.filterMenuParms.filterAmountElements = this.amountElements;
    },
    handleSetFilterName() {
      this.$parent.filterMenuParms.filterName = this.name;
    },
    handleState(state) {
      this.$parent.filterMenuParms.filterState = state;
    },
    handleOrderBy(sort, asc) {
      this.$parent.filterMenuParms.orderBy = {
        sort,
        asc,
      };
    },
  },
  created: function () {},
};
</script>

<style>
</style>